const cdnBaseUrl = 'https://cdn.lyearn.com';
export enum ImageTypeEnum {
  Badges = 'Badges',
}
export const StaticImages = {
  [ImageTypeEnum.Badges]: [
    {
      url: `${cdnBaseUrl}/assets/badges/content_conqueror.png`,
      name: 'Content conqueror',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/gold_star.png`,
      name: 'Gold star',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/knowledge_seeker.png`,
      name: 'Knowledge seeker',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/learning_streak.png`,
      name: 'learning streak',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/master_of_mastery.png`,
      name: 'Master of mastery',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/momentum.png`,
      name: 'Momentum',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/panctual.png`,
      name: 'Panctual',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/precision_pioneer.png`,
      name: 'Precision pioneer',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/rising_star.png`,
      name: 'Rising star',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/skill_champion.png`,
      name: 'Skill champion',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/skill_excellence.png`,
      name: 'Skill excellence',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/sprint_master.png`,
      name: 'Sprint master',
      type: ImageTypeEnum.Badges,
    },
    {
      url: `${cdnBaseUrl}/assets/badges/steady_streaker.png`,
      name: 'Steady streaker',
      type: ImageTypeEnum.Badges,
    },
  ],
};
